module.exports = __webpack_public_path__ + "static/5a40b0fe-88e7-481d-bd9c-f60405aa2a3d-250.3fc927e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/objects/st-thomas-church-fifth-avenue/5a40b0fe-88e7-481d-bd9c-f60405aa2a3d-250.jpg
// module id = 1233
// module chunks = 168707334958949